// Feature flags configuration for the application
const urlParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;

export const showWhatsappExtraPages = 
  process.env.REACT_APP_EXTRA_WHATSAPP_PAGES === 'true' || 
  (urlParams && urlParams.get('env') === 'prod');

// Feature Flag: Enable the Campaigns feature
export const showCampaigns = true;

// Feature Flag: Enable the Contacts feature
export const showContacts = true;

// Feature Flag: Enable the Workflow feature
export const showWorkflows = true;

// Feature Flag: Enable the AI template generation feature
export const showAITemplateGenerator = true;

// Feature Flag: Enable the Template Library cloning features
export const showTemplateLibrary = true;

// Feature Flag: Enable the Create Conversation feature
export const showCreateConversation = true;
